define('SC.HorizonThemeExtension.Common.Configuration', [], function () {
  'use strict';
  var environment = null;
  return {
    setEnvironment: function setEnvironment(environmentComponent) {
      environment = environmentComponent;
    },
    get: function get(key) {
      if (environment) {
        return environment.getConfig(key);
      }
      console.error(
        'Please set the Environment Component in the Configuration.'
      );
      return null;
    },
    getOverallConfiguration: function () {
      return environment.application.getConfig();
    }
  };
});
